export const buildAddressString = function(addressData) {
  if (!addressData) {
    return '';
  }

  const { address, city, state, country, postal_code, zip_code } = addressData;

  let addressString = '';
  if (address) addressString += address;
  if (city) addressString += ' ' + city;
  if (state) addressString += ' ' + state;
  if (country) addressString += ' ' + country;
  if (postal_code) addressString += ' ' + postal_code;
  if (zip_code) addressString += ' ' + zip_code;

  return addressString;
};
